import { GETNewsByIdWithSymbol } from '@fe-news/api/news';

export const fetchRelatedNewsById = async (id: number, limit: number) => {
  const data = await GETNewsByIdWithSymbol({ id, symbol: '0' });

  const items = (data?.items as News) || ({} as News);

  const related = Array.isArray(items?.related) ? items.related : [];

  return related.slice(0, limit);
};
